import { Component, OnInit, Input } from "@angular/core";
import { AlternativeBidRequest } from "src/app/shared/services/dealer.service";

@Component({
  selector: "app-card-alternative-bind-request",
  templateUrl: "./alternative-bind-request.component.html",
  styleUrls: ["./alternative-bind-request.component.scss"],
})
export class AlternativeBindRequestComponent implements OnInit {
  @Input() alternativeBinds: AlternativeBidRequest[];

  constructor() {}

  ngOnInit() {}
  getLabel(alternativeBid: AlternativeBidRequest) {
    switch (alternativeBid.status) {
      case "REJECTED":
        return "Proposta rejeitada";
      case "ACCEPTED":
        return "Proposta aceita";
      default:
        return "Em análise";
    }
  }
}
